export const MAP_GEOFENCES_DELETE_OPEN_MODAL = "MAP_GEOFENCES_DELETE_OPEN_MODAL";
export const MAP_GEOFENCES_DELETE_GEOFENCE = "MAP_GEOFENCES_DELETE_GEOFENCE";
export const MAP_GEOFENCES_DELETE_GEOFENCE_RESPONSE = "MAP_GEOFENCES_DELETE_GEOFENCE_RESPONSE";